import { render, staticRenderFns } from "./GbdflSearch.vue?vue&type=template&id=08806465"
import script from "./GbdflSearch.vue?vue&type=script&lang=js"
export * from "./GbdflSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports